import * as React from 'react';
import Money from '../../Money';
import { useContext } from 'react';
import { CartContext } from '../Cart';
import { BaseButton } from '../../BaseComponents';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../theme';
const Toolbar = ({ onClick }) => {
    const cartContext = useContext(CartContext);
    const { t } = useTranslation('Cart');
    const theme = useTheme('Cart').Toolbar;
    return (React.createElement("div", { className: theme.container },
        React.createElement("div", { className: theme.money }, cartContext.totalPrices.total.amount > 0 && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: theme.from }, t('Total')),
            React.createElement(Money, { money: cartContext.totalPrices.total })))),
        React.createElement(BaseButton, { className: theme.close, variant: "action", onClick: onClick }, t('Close'))));
};
export default Toolbar;
